import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/deployments/detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* fetchDeploymentDetailData(action) {
  try {
    const { promotion_id } = action.payload;
    
    const response = yield call(
      axios.get,
      `${config.API_URL}/deployments/${promotion_id}`,
      { headers: getLocalUser() }
    );
    
    yield put(fetchSuccess(response.data));
    
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchDeploymentDetailData);
}









